import { z } from 'zod'

/** Response-only: replay loads current authorized state without another write. */
export const FinancialCommandResultSchema = z.object({
  operationId: z.string().uuid(),
  replayed: z.boolean(),
})
export type FinancialCommandResult = z.infer<
  typeof FinancialCommandResultSchema
>
